/**
 * @module getActionEndpoint
 */

import { isFeatureEnabled } from 'owa-feature-flags';
import { getItem } from 'owa-local-storage';
import { ACTION_ENDPOINT_LOCAL_STORAGE_KEY, DEFAULT_ACTION_ENDPOINT_URL } from '../constants';
import actionEndpointStore from '../store/actionEndpointStore';
import { ActionEndpointCacheData } from '../store/schema/actionEndpointCache';
import doesActionEndpointExistInCache from '../utils/doesActionEndpointExistInCache';

/**
 * @function
 * To get the action endpoint from the local storage
 * @returns the action endpoint json
 */
export const getActionEndpointFromCache = () => {
    if (!doesActionEndpointExistInCache()) {
        return null;
    }
    return JSON.parse(getItem(window, ACTION_ENDPOINT_LOCAL_STORAGE_KEY));
};

/**
 * @function
 * To get the action endpoint data dictionary from the satchel store
 * @returns {ActionEndpointCacheData} the action endpoint url
 */
export const getActionEndpointDataFromStore = (): ActionEndpointCacheData => {
    return actionEndpointStore.cache.data;
};

/**
 * @function
 * To get the action endpoint url from the satchel store
 * @returns {string} the action endpoint url
 */
export const getActionEndpointUrlFromStore = (): string => {
    return isFeatureEnabled('rp-actionableMessagesAutoD')
        ? actionEndpointStore.cache.data.Url
        : DEFAULT_ACTION_ENDPOINT_URL;
};
